
export default (https) => ({
  async getList(params = []) {
    const queryString = params
      .filter(param => param.value !== null && param.value !== undefined && param.value !== '')
      .map(param => `${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`)
      .join('&');

    const response = await https.get(`/general-settings?${queryString}`);
    return response.data;
  },
  async update(payload) {
    const response = await https.post(`/general-settings`, payload);
    return response.data;
  },

});
